// removed by extract-text-webpack-plugin
module.exports = {"raceCardContainer":"_1aWCBth8iQLHZJ9z7fdxnw","raceCardContent":"_1GESi76-pZ3D_rQQ_VISB3","gameCardContainer":"_2tUFjuXzMvS-7A9JEnd2UH","bettingTypeToogleSlider":"_2rIXNF1ABm6iDe4mNH4RLB","selected":"woBVHdfog4OlbsfHPDCmY","text":"_2IZ7a31xZbAbkoCs6jnf6E","arrowIconContainer":"yGKLbBke8ma1vRRg3lnUf","arrowIcon":"HWK2PlDIsGo8WLKsAxDDP"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/desktop/modules/racing/css/raceCard.css
// module id = 1047
// module chunks = 0